import * as React from "react";
import type { SVGProps } from "react";
const SvgEliminateBarriers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={65}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M38.581.78c0-.43.35-.78.78-.78h18.7c3.826 0 6.926 3.1 6.926 6.927v18.527a.78.78 0 1 1-1.561 0V6.927a5.365 5.365 0 0 0-5.365-5.366h-18.7a.78.78 0 0 1-.78-.78ZM64.215 37.59c.431 0 .78.35.78.78v18.703c0 3.826-3.1 6.927-6.925 6.927h-18.7a.78.78 0 0 1 0-1.561h18.7a5.365 5.365 0 0 0 5.365-5.366V38.371c0-.431.35-.78.78-.78ZM1.776 37.688c.431 0 .78.35.78.78v18.605a5.365 5.365 0 0 0 5.366 5.366h18.241a.78.78 0 0 1 0 1.56H7.922a6.926 6.926 0 0 1-6.926-6.926V38.468c0-.43.35-.78.78-.78ZM.996 6.927C.996 3.1 4.096 0 7.922 0h18.241a.78.78 0 0 1 0 1.561H7.922a5.365 5.365 0 0 0-5.365 5.366v18.527a.78.78 0 1 1-1.56 0V6.927Z"
      clipRule="evenodd"
    />
    <path fill="#26A3DD" d="m32.806 4.556.205 54.898-.205-54.898Z" />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M32.802 3.776a.78.78 0 0 1 .783.777l.205 54.898a.78.78 0 0 1-1.56.005L32.023 4.56a.78.78 0 0 1 .778-.783Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m32.782 2.885 7.138 7.585a.78.78 0 0 1-1.137 1.07l-5.972-6.347-5.754 6.43a.78.78 0 1 1-1.163-1.041l6.888-7.697ZM25.944 53.02a.78.78 0 0 1 1.103.038l5.96 6.397 5.77-6.295a.78.78 0 1 1 1.15 1.055l-6.911 7.54-7.111-7.633a.78.78 0 0 1 .039-1.103Z"
      clipRule="evenodd"
    />
    <path fill="#26A3DD" d="m5.152 32.43 54.889-.206-54.89.205Z" />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M60.822 32.221a.78.78 0 0 1-.778.784l-54.89.205a.78.78 0 0 1-.005-1.561l54.89-.205a.78.78 0 0 1 .782.777Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M12.167 25.348a.78.78 0 0 1-.033 1.103l-6.346 5.974 6.429 5.754a.78.78 0 0 1-1.041 1.163L3.48 32.453l7.584-7.138a.78.78 0 0 1 1.103.033ZM53.7 25.355a.78.78 0 0 1 1.103-.047l7.549 6.922-7.643 7.103a.78.78 0 1 1-1.062-1.144l6.404-5.951-6.303-5.78a.78.78 0 0 1-.048-1.103Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEliminateBarriers;
